var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoor = function SvgDoor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 15,
    cy: 12,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5996 3C17.4393 3 17.8598 2.99981 18.1807 3.16309C18.4629 3.3069 18.6931 3.53709 18.8369 3.81934C19.0002 4.14015 19 4.56068 19 5.40039V18.5996C19 19.4393 19.0002 19.8598 18.8369 20.1807C18.6931 20.4629 18.4629 20.6931 18.1807 20.8369C17.8598 21.0002 17.4393 21 16.5996 21H7.40039C6.56068 21 6.14015 21.0002 5.81934 20.8369C5.53709 20.6931 5.3069 20.4629 5.16309 20.1807C4.99981 19.8598 5 19.4393 5 18.5996V5.40039C5 4.56068 4.99981 4.14015 5.16309 3.81934C5.3069 3.53709 5.53709 3.3069 5.81934 3.16309C6.14015 2.99981 6.56068 3 7.40039 3H16.5996ZM15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "door.903c105836e493e6e52baee46eae6df6.svg";